
export default function BlogDetails() {
  return (
<> 
<section class="vs-blog-wrapper blog-details space-top space-extra-bottom">
    <div class="container">
      <div class="row">
        <div class="col-xl-8 col-lg-7">
          <div class="vs-blog blog-single">
            <div class="blog-img wow animate__fadeInUp" data-wow-delay="0.30s">
              <img src="assets/img/blog/blog-d-1.jpg" alt="blog image"/>
              <div class="blog-tag">Thriller</div>
              <div class="blog-meta">
                <a href="blog.html"><i class="fas fa-calendar-alt"></i>16 March, 2025</a>
                <a href="blog.html"><i class="fas fa-comments"></i>(13) Comment</a>
                <a href="blog.html"><i class="fas fa-eye"></i>(63) View</a>
              </div>
            </div>
            <div class="blog-content wow animate__fadeInUp" data-wow-delay="0.50s">
              <h2 class="blog-title">Lorem ipsum dolor sit amet consect etur adipiscing elit.</h2>
              <p class="blog-text">
                Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat.
                In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla
                lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel
                class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos aptent taciti sociosqu.
              </p>
              <p class="blog-text mb-30">dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat.
                In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla
                lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia.
              </p>
              <div class="row mb-3">
                <div class="col-lg-6">
                  <div class="list-style1">
                    <ul class="list-unstyled">
                      <li><i class="fa-solid fa-circle-check"></i>Focus on Your Riding Posture</li>
                      <li><i class="fa-solid fa-circle-check"></i>Work on Your Leg Position</li>
                      <li><i class="fa-solid fa-circle-check"></i>Improve Your Communication With Horse</li>
                      <li><i class="fa-solid fa-circle-check"></i>Strengthen Your Core Muscles</li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="list-style1">
                    <ul class="list-unstyled">
                      <li><i class="fa-solid fa-circle-check"></i>Practice Regularly with a Plan</li>
                      <li><i class="fa-solid fa-circle-check"></i>Take Riding Lessons with Qualified Instructor</li>
                      <li><i class="fa-solid fa-circle-check"></i>Make Better Understand Horse Behavior</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="blog-video mb-35 wow animate__fadeInUp" data-wow-delay="0.50s">
                <img src="assets/img/blog/blog-d-2.jpg" alt="blog image"/>
                <a href="https://www.youtube.com/watch?v=_sI_Ps7JSEk" class="play-btn popup-video">
                  <i class="fas fa-play"></i>
                </a>
              </div>
              <p class="blog-text">
                Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat.
                In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla
                lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel
                class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos semper vel class aptent taciti.
              </p>
              <blockquote class="vs-quote">
                <p>"Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat.
                  In id cursus mi pretium tellus duis convallis. "</p>
                <cite>Rodja Heartmann</cite>
                <span class="quote-icon"><img src="assets/img/icons/quote-icon.svg" alt="icon"/></span>
              </blockquote>
              <p class="blog-text mb-30">
                Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat.
                In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla
                lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu.
              </p>
              <div class="blog-group-imgs mb-30 wow animate__fadeInUp" data-wow-delay="0.60s">
                <div class="row g-5">
                  <div class="col-md-6"><img src="assets/img/blog/blog-d-3.jpg" alt="blog-details"/></div>
                  <div class="col-md-6"><img src="assets/img/blog/blog-d-4.jpg" alt="blog-details"/></div>
                </div>
              </div>
              <p class="blog-text">
                Having specific objectives can accelerate your progress. Whether it's mastering a new gait or
                improving your jumping technique, set achievable goals and track your progress. Even the best
                riders benefit from a fresh perspective. A qualified instructor can help you identify areas for
                improvement, refine your techniques, and break bad habits. A great rider understands not only the
                mechanics of riding but also the psychology of horses. Learn to read your horse’s body language,
                moods, and reactions to create a harmonious partnership.
              </p>
              <div class="share-links">
                <div class="row align-items-center">
                  <div class="col-xl-6 col-lg-auto">
                    <div class="tagcloud">
                      <span class="share-links-title">Tags:</span>
                      <a href="blog.html">Books</a>
                      <a href="blog.html">Thriller</a>
                      <a href="blog.html">Suspense</a>
                    </div>
                  </div>
                  <div class="col-xl-6 col-lg-auto">
                    <ul class="social-links">
                      <li><span class="share-links-title">Share:</span></li>
                      <li><a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                      <li><a href="#" target="_blank"><i class="fa-brands fa-x-twitter"></i></a></li>
                      <li><a href="#" target="_blank"><i class="fab fa-instagram"></i></a></li>
                      <li><a href="#" target="_blank"><i class="fab fa-dribbble"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="blog-author">
                <div class="media-img">
                  <img src="assets/img/blog/blog-author.jpg" alt="Blog Author Image"/>
                </div>
                <div class="media-body">
                  <h3 class="author-name h4"><a href="author-details.html">Ronald Richards</a></h3>
                  <p class="author-degi">CEO, Vecuro</p>
                  <p class="author-text">Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque vitae is
                    faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. </p>
                  <ul class="social-links">
                    <li><a href="#" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                    <li><a href="#" target="_blank"><i class="fa-brands fa-x-twitter"></i></a></li>
                    <li><a href="#" target="_blank"><i class="fab fa-instagram"></i></a></li>
                    <li><a href="#" target="_blank"><i class="fab fa-dribbble"></i></a></li>
                  </ul>
                </div>
              </div>
              <div class="vs-comments-wrap wow animate__fadeInUp" data-wow-delay="0.70s">
                <h2 class="blog-inner-title title-shep">Comment</h2>
                <ul class="comment-list">
                  <li class="vs-comment-item">
                    <div class="vs-post-comment">
                      <div class="comment-avater">
                        <img src="assets/img/blog/comment-author-1.jpg" alt="Comment Author"/>
                      </div>
                      <div class="comment-content">
                        <span class="commented-on"><i class="fas fa-calendar-alt"></i>July 21, 2025</span>
                        <h4 class="name h4">Rodja Heartmann</h4>
                        <p class="text">Lorem lipsum dolor sit amet, adipiscfvdg fgjnving consectetur adipiscing elit
                          dolor sit .consectetur adipiscing elit. dolor sit amet.</p>
                        <div class="reply_and_edit">
                          <a href="blog-details.html" class="replay-btn">Reply</a>
                        </div>
                      </div>
                    </div>
                    <ul class="children">
                      <li class="vs-comment-item">
                        <div class="vs-post-comment">
                          <div class="comment-avater">
                            <img src="assets/img/blog/comment-author-2.jpg" alt="Comment Author"/>
                          </div>
                          <div class="comment-content">
                            <span class="commented-on"><i class="fas fa-calendar-alt"></i>July 25, 2025</span>
                            <h4 class="name h4">Rivanur R. Rafi</h4>
                            <p class="text">Lorem lipsum dolor sit amet, adipiscfvdg fgjnving consectetur adipiscing elit
                              dolor sit amet. dolor sit amet.</p>
                            <div class="reply_and_edit">
                              <a href="blog-details.html" class="replay-btn">Reply</a>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <div class="vs-comment-form wow animate__fadeInUp" data-wow-delay="0.80s">
                <div id="respond" class="comment-respond mb-0">
                  <div class="form-title">
                    <h3 class="blog-inner-title title-shep">Comment</h3>
                  </div>
                  <div class="form-inner">
                    <div class="row gx-30">
                      <div class="col-md-6 form-group">
                        <input type="text" class="form-control" placeholder="Complete Name"/>
                      </div>
                      <div class="col-md-6 form-group">
                        <input type="email" class="form-control" placeholder="Your Email"/>
                      </div>
                      <div class="col-12 form-group">
                        <textarea class="form-control" placeholder="Comment"></textarea>
                      </div>
                      <div class="col-12 ">
                        <div class="custom-checkbox notice">
                          <input id="wp-comment-cookies-consent" name="wp-comment-cookies-consent" type="checkbox" value="yes"/>
                          <label for="wp-comment-cookies-consent"> Save my name, email, and website in this browser for
                            the next time I comment.</label>
                        </div>
                      </div>
                      <div class="col-12 form-group mb-0">
                        <button class="vs-btn">Submit A Comment</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-5">
          <aside class="sidebar-area">
            <div class="widget widget_search wow animate__fadeInUp" data-wow-delay="0.30s">
              <h3 class="wp-block-heading widget_title title-shep">Search</h3>
              <form class="search-form">
                <input type="text" placeholder="Search Here..."/>
                <button class="vs-btn" type="submit">Search</button>
              </form>
            </div>
            <div class="widget wow animate__fadeInUp" data-wow-delay="0.40s">
              <div class="wp-block-group widget_categories is-layout-constrained wp-block-group-is-layout-constrained">
                <div class="wp-block-group__inner-container">
                  <h3 class="wp-block-heading widget_title title-shep">Categories</h3>
                  <ul class="wp-block-categories-list wp-block-categories">
                    <li class="cat-item">
                      <a href="blog.html">Romance</a>
                    </li>
                    <li class="cat-item">
                      <a href="blog.html">Thriller</a>
                    </li>
                    <li class="cat-item">
                      <a href="blog.html">Fantasy</a>
                    </li>
                    <li class="cat-item">
                      <a href="blog.html">Since Fiction</a>
                    </li>
                    <li class="cat-item">
                      <a href="blog.html">Since</a>
                    </li>
                    <li class="cat-item">
                      <a href="blog.html">Astronomy</a>
                    </li>
                    <li class="cat-item">
                      <a href="blog.html">Kids</a>
                    </li>
                    <li class="cat-item">
                      <a href="blog.html">Cartoon & Story</a>
                    </li>
                    <li class="cat-item">
                      <a href="blog.html">Educational</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="widget wow animate__fadeInUp" data-wow-delay="0.50s">
              <h3 class="widget_title title-shep">Latest News</h3>
              <div class="recent-post-wrap">
                <div class="recent-post">
                  <div class="media-img">
                    <a href="blog-details.html"><img src="assets/img/blog/recent-post-1-1.jpg" alt="Blog Image"/></a>
                  </div>
                  <div class="media-body">
                    <div class="recent-post-meta">
                      <i class="fas fa-calendar-alt"></i> 16 January, 2025
                    </div>
                    <h4 class="post-title"><a class="text-inherit" href="blog-details.html">Lorem ipsum dolor sit amet consectetur.</a></h4>
                  </div>
                </div>
                <div class="recent-post">
                  <div class="media-img">
                    <a href="blog-details.html"><img src="assets/img/blog/recent-post-1-2.jpg" alt="Blog Image"/></a>
                  </div>
                  <div class="media-body">
                    <div class="recent-post-meta">
                      <i class="fas fa-calendar-alt"></i> 16 January, 2025
                    </div>
                    <h4 class="post-title"><a class="text-inherit" href="blog-details.html">How to Improve amet Your Riding Skills</a></h4>
                  </div>
                </div>
                <div class="recent-post">
                  <div class="media-img">
                    <a href="blog-details.html"><img src="assets/img/blog/recent-post-1-3.jpg" alt="Blog Image"/></a>
                  </div>
                  <div class="media-body">
                    <div class="recent-post-meta">
                      <i class="fas fa-calendar-alt"></i> 16 January, 2025
                    </div>
                    <h4 class="post-title"><a class="text-inherit" href="blog-details.html">Lorem ipsum dolor sit amet consectetur.</a></h4>
                  </div>
                </div>
              </div>
              </div>
          </aside>
        </div>
      </div>
    </div>
  </section>

  <section class="cta-layout1 z-index-common blog-title">
    <div class="container">
      <div class="row gx-60 align-items-center">
        <div class="col-lg-3">
          <div class="cta-logo">
            <a href="index.html"><img src="assets/img/logo.svg" alt="Ebukz" class="logo"/></a>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="row justify-content-xl-between justify-content-center align-items-center">
            <div class="col-xl-4 col-lg-5">
              <div class="newsletter-inner">
                <span class="newsletter-icon"><img src="assets/img/icons/mail-2.svg" alt="icon"/></span>
                <div class="newsletter-content">
                  <h4 class="newsletter_title">Get In Touch</h4>
                  <p class="newsletter-text">Subscribe for more Update</p>
                </div>
              </div>
            </div>
            <div class="col-xl-8 col-lg-7">
              <div class="newsletter-form">
                <div class="search-btn">
                  <input class="form-control" type="email" placeholder="Your Email Address"/>
                  <button type="submit" class="vs-btn"><i class="fa-solid fa-paper-plane"></i> Subscribe</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </>

      );
}